"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _colors = require("HubStyleTokens/colors");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIClickable = _interopRequireDefault(require("../../button/UIClickable"));

var _HoverProvider = _interopRequireDefault(require("../../providers/HoverProvider"));

var _Styles = require("../../utils/Styles");

var getBorderColor = function getBorderColor(_ref) {
  var ariaPressed = _ref['aria-pressed'],
      hovered = _ref.hovered,
      active = _ref.active,
      disabled = _ref.disabled;

  if (!disabled) {
    if (ariaPressed || active) return _colors.FLINT;
    if (hovered) return _colors.BATTLESHIP;
  }

  return 'transparent';
};

var Clickable = (0, _styledComponents.default)(function (props) {
  var __hovered = props.hovered,
      __use = props.use,
      __useNativeButton = props._useNativeButton,
      __active = props.active,
      rest = (0, _objectWithoutProperties2.default)(props, ["hovered", "use", "_useNativeButton", "active"]);
  return _react.default.createElement(_UIClickable.default, rest);
}).withConfig({
  displayName: "SimpleStyledClickable__Clickable",
  componentId: "sc-1i0t19r-0"
})(["background:", ";border:1px solid ", ";border-radius:3px;display:inline-block;height:27px;padding:0 4px 0 4px;vertical-align:middle;", ";&&{cursor:", ";}"], function (_ref2) {
  var ariaPressed = _ref2['aria-pressed'],
      active = _ref2.active;
  return ariaPressed || active ? _colors.BATTLESHIP : '';
}, getBorderColor, (0, _Styles.setUiTransition)(), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'initial';
});

var SimpleStyledClickable = function SimpleStyledClickable(props) {
  return _react.default.createElement(_HoverProvider.default, props, function (hoverProviderProps) {
    return _react.default.createElement(Clickable, Object.assign({}, props, hoverProviderProps));
  });
};

SimpleStyledClickable.displayName = 'SimpleStyledClickable';
var _default = SimpleStyledClickable;
exports.default = _default;
module.exports = exports.default;